import { render, staticRenderFns } from "./realname-approval.vue?vue&type=template&id=180b2b62&scoped=true&"
import script from "./realname-approval.vue?vue&type=script&lang=js&"
export * from "./realname-approval.vue?vue&type=script&lang=js&"
import style0 from "./realname-approval.vue?vue&type=style&index=0&id=180b2b62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b2b62",
  null
  
)

export default component.exports